'use client'

import { useAuth } from '@clerk/nextjs'
import { useFeatureAccess } from './useFeatureAccess'

const HREF_UNAUTHENTICATED = '/strefa-nauki'
const HREF_HAS_ACCESS = '/user/tests-and-games/'
const HREF_NO_ACCESS = '/user/kup-dostep'

/**
 * Returns the correct href for the "strefa nauki / tests & games" entry point:
 * - Not signed in → /strefa-nauki
 * - Signed in + has access → /user/tests-and-games/
 * - Signed in + no access → /user/kup-dostep
 *
 * Falls back to /strefa-nauki while auth or access is still loading.
 */
export function useTestsAndGamesHref(): string {
  const { isSignedIn, isLoaded } = useAuth()
  const { featureAccess, isLoading: isAccessLoading } = useFeatureAccess()

  if (!isLoaded || !isSignedIn) return HREF_UNAUTHENTICATED
  if (isAccessLoading) return HREF_UNAUTHENTICATED

  return featureAccess?.questions ? HREF_HAS_ACCESS : HREF_NO_ACCESS
}
